import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-lg-3 col-md-6" }
const _hoisted_3 = { class: "col-lg-3 col-md-6" }
const _hoisted_4 = { class: "col-lg-3 col-md-6" }
const _hoisted_5 = { class: "col-lg-3 col-md-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TicketsResolvedChart = _resolveComponent("TicketsResolvedChart")!
  const _component_TicketsInProgressChart = _resolveComponent("TicketsInProgressChart")!
  const _component_TicketsDueChart = _resolveComponent("TicketsDueChart")!
  const _component_TicketsNewOpenChart = _resolveComponent("TicketsNewOpenChart")!
  const _component_AllTickets = _resolveComponent("AllTickets")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_TicketsResolvedChart)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TicketsInProgressChart)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_TicketsDueChart)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_TicketsNewOpenChart)
      ])
    ]),
    _createVNode(_component_AllTickets)
  ]))
}